import { Component, Input, TemplateRef } from '@angular/core';

let nextCollapseTitleId = 0;
let nextCollapseContentId = 0;

@Component({
  selector: 'app-collapse',
  templateUrl: 'collapse.component.html',
  styles: [`
.collapse, .collapse.show {
  transition: all 0.2s ease-in-out;
}
.collapse {
  display: none;
  opacity: 0;
  height: 0;
}
.collapse.show {
  display: block;
  opacity: 1;
  height: auto;
}
.arrowIcon {
  -moz-transition: all 0.2s linear;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
}
.turnIcon {
  -ms-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}`]
})
export class CollapseComponent {
  @Input() collapsed: boolean = true;
  @Input() className: string = '';
  @Input() title: string;
  @Input() content: string;
  @Input() template: TemplateRef<any>;

  readonly collapseTitleId: string = `collapse-title-${++nextCollapseTitleId}`;
  readonly collapseContentId: string = `collapse-body-${++nextCollapseContentId}`;

  get collapseContentClasses() {
    return 'my-4 ' + this.className;
  }

  toggleCollapsed(event: Event): void {
    event.preventDefault();
    this.collapsed = !this.collapsed;
  }
}



// WEBPACK FOOTER //
// ./src/app/global/collapse.component.ts